export default "__VITE_ASSET__CUiFVR5Y__"